import { DESKTOP_FEATURES } from '../content';

const downloads = [
  { icon: 'ri-apple-line', label: 'Download for Mac' },
  { icon: 'ri-windows-line', label: 'Download for Windows' },
];

export default function StudioSection() {
  return (
    <section id="studio" className="py-16 md:py-20 border-t border-border">
      <div className="max-w-[1040px] mx-auto px-6">
        <div className="max-w-[620px]">
          <h2 className="font-heading text-2xl md:text-3xl tracking-tight text-textp font-semibold">
            For teams who want the graph
          </h2>
          <p className="mt-3 text-texts leading-relaxed">
            Studio is the step canvas. Most founders never start here. It stays available after you begin a build, including a desktop window when downloads ship.
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
          {DESKTOP_FEATURES.map((f) => (
            <div key={f.title} className="bg-surface border border-border rounded-xl p-5">
              <span className="w-9 h-9 rounded-lg bg-accentSoft border border-accentLine flex items-center justify-center">
                <i className={`${f.icon} text-accent text-base`} />
              </span>
              <h3 className="mt-3 text-sm text-textp font-medium">{f.title}</h3>
              <p className="mt-1.5 text-sm text-texts leading-relaxed">{f.body}</p>
            </div>
          ))}
        </div>

        <div className="mt-6 flex flex-col sm:flex-row items-center gap-3" data-testid="desktop-downloads">
          {downloads.map((d) => (
            <button
              key={d.label}
              type="button"
              disabled
              className="whitespace-nowrap flex items-center gap-2 bg-surface border border-border text-texts text-sm font-medium px-5 py-2.5 rounded-lg cursor-not-allowed"
            >
              <i className={`${d.icon} text-base`} />
              {d.label}
              <span className="text-[10px] uppercase tracking-[0.12em] text-texts border border-border rounded-full px-2 py-0.5">
                Coming soon
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
